<template>
  <ConfigProvider :locale="zhCN">
    <RouterView />
  </ConfigProvider>
</template>
<script setup lang="ts">
import { watch } from 'vue';

import { ConfigProvider, message } from 'ant-design-vue';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import { useFullscreen } from '@vueuse/core';

dayjs.locale('zh-cn');
const { isFullscreen } = useFullscreen();
watch(
  () => isFullscreen.value,
  () => {
    if (isFullscreen.value) {
      message.config({
        getContainer: (): any => window.document.getElementById('containerRef'),
      });
    } else {
      message.config({
        getContainer: (): any => window.document.body,
      });
    }
  }
);
</script>
